"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vars = exports.default = exports.common = void 0;
var _Text = require("../Text/Text.util");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var common = exports.common = ["margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "flex", "flexGrow", "flexShrink"];
var vars = exports.vars = (0, _initVars.default)({
  applied: common,
  variables: [{
    key: "chipSelectedColor",
    canHaveColor: true
  }, {
    key: "chipSelectedContentColor",
    canHaveColor: true
  }]
});
var chipStyles = function chipStyles(theme) {
  return {
    variables: vars.styles,
    root: _objectSpread({
      position: "relative",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      background: "transparent",
      borderRadius: 2,
      transition: "background 250ms ease-in-out, border-color 250ms ease-in-out, color 250ms ease-in-out",
      fontFamily: theme.typography.fontFamily,
      letterSpacing: theme.typography.letterSpacing,
      textTransform: "uppercase",
      color: theme.colors.baseContrast100,
      "& *": {
        transition: "color 250ms ease-in-out, fill 70ms ease-in-out",
        color: theme.colors.baseContrast100,
        fill: theme.colors.baseContrast100
      }
    }, (0, _Text.setTextCssVars)({
      fontSize: theme.typography.fontSize,
      fontWeight: 500
    })),
    small: {
      height: theme.spacing.base * 3,
      padding: [0, theme.spacing.base * 1.2]
    },
    medium: {
      height: theme.spacing.base * 4,
      padding: [0, theme.spacing.base * 1.8]
    },
    large: {
      height: theme.spacing.base * 4.5,
      padding: [0, theme.spacing.base * 2]
    },
    input: {
      position: "absolute",
      width: 1,
      height: 1,
      opacity: 0
    },
    inputRelated: {
      cursor: "pointer",
      userSelect: "none",
      webkitUserSelect: "none",
      "&:has(input:checked)": {
        background: vars.get("chipSelectedColor"),
        color: vars.get("chipSelectedContentColor"),
        "& *": {
          color: vars.get("chipSelectedContentColor"),
          fill: vars.get("chipSelectedContentColor")
        }
      },
      "&:has(input:disabled)": {
        cursor: "not-allowed",
        color: theme.colors.baseContrast040
      }
    }
  };
};
var useStylesChip = (0, _createUseStyles.default)(chipStyles, {
  name: "Chip"
});
var _default = exports.default = useStylesChip;